// src/navigation/tabs/components/TabNavigation.tsx

import React from "react";
import { NavLink } from "react-router-dom";
import { TabItem } from "../TabsTypes";
import classes from "./TabNavigation.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconProp } from "@fortawesome/fontawesome-svg-core";

interface TabNavigationProps {
  items: TabItem[];
  selectedTab: TabItem | undefined;
  onSelect: (tabItem: TabItem) => void;
}

const TabNavigation: React.FC<TabNavigationProps> = ({ items, selectedTab, onSelect }) => (
  <>
    {items.map((item) => {
      const isActive = item.path === selectedTab?.path;
      return (
        <NavLink
          key={item.path}
          to={item.path}
          className={classes.tabItem}
          data-color={item.color}
          style={{ "--tab-accent": item.color } as React.CSSProperties}
          onClick={() => onSelect(item)}
        >
          <label className={isActive ? classes.selectedTab : classes.tab}>
            {item.icon && <FontAwesomeIcon icon={item.icon as IconProp} />} {item.label}
          </label>
          {isActive && <div className={classes.tabSelectedLine} />}
        </NavLink>
      );
    })}
  </>
);

export default TabNavigation;
